import {
  LocationGeographicalCenter,
  LocationFilterInputObject,
  useSectorLocationCenterQuery,
  SectorLocationCenterQueryVariables,
} from 'graphql-common';
import createSearchFilters from '@lib/utils/createSearchFilters';
import { ApolloError } from '@apollo/client';

type Args = {
  additionalFilters?: object[];
  defaultFilters?: object[];
  searchQuery?: string;
  skip?: boolean;
};

export type UseSectorLocationCenterQueryHookResult = {
  data?: LocationGeographicalCenter;
  error: ApolloError | undefined;
  firstLoading: boolean;
  loading: boolean;
  refetch: () => Promise<unknown>;
};

export default function useSectorLocationCenterQueryHook(
  args: Args,
): UseSectorLocationCenterQueryHookResult {
  const { additionalFilters, searchQuery, skip, defaultFilters = [] } = args;
  const filters: LocationFilterInputObject[] = [...defaultFilters];
  const variables: SectorLocationCenterQueryVariables = {};
  if (searchQuery) {
    filters.push(
      ...createSearchFilters(searchQuery, [
        { fieldName: 'areasCode' },
        { fieldName: 'areasName' },
        { fieldName: 'code' },
        { fieldName: 'name' },
        { fieldName: 'userFullName' },
        { fieldName: 'siteName' },
      ]),
    );
  }
  if (additionalFilters?.length) {
    variables.sectorFilters = additionalFilters;
  }
  if (filters.length) {
    variables.filters = filters;
  }
  const query = useSectorLocationCenterQuery({
    variables,
    fetchPolicy: 'network-only',
    skip,
  });
  const { data: queryData, refetch, loading, error, previousData } = query;
  const data = queryData || previousData;
  const firstLoading = loading && queryData === undefined;

  return {
    data: data?.data ? { lat: data?.data.lat, lon: data.data.lon } : undefined,
    error,
    firstLoading,
    loading,
    refetch,
  };
}
